import React from 'react'
import ReactDOM from 'react-dom'
import { findWhere } from 'underscore'
import { animateScroll } from 'react-scroll'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { postViewHistory, updateViewHistory } from '~/actions/viewhistory'
import { fetchArticle, fetchComments, fetchRecommendedArticles, removeArticle } from '~/actions/article'

import MetaData from '~/components/MetaData'
import { TextLoader } from '~/components'

import {
	Actions,
	Comments,
	Content,
	FeaturedImage,
	NoArticle,
	Ranking,
	Recommended,
	SocialIcons,
	User
} from './components'

const getState = props => {

    const feedPost = findWhere(props.feed.posts, {url_slug: props.match.params.slug});
    //console.log(feedPost)
    if( !!feedPost ) return { article: feedPost }

    const archivePost = findWhere(props.articles.all, {url_slug: props.match.params.slug});
    //console.log(archivePost)
    if( !!archivePost ) return { article: archivePost }

    var fetchedPost = props.article.post;
    //console.log(fetchedPost)
    if( 'ID' in fetchedPost ) return { article: fetchedPost }

    return { article: {} };

}

class Article extends React.Component {
    state = getState(this.props);
    progress = 0;

    componentWillMount(nextProps, nextState) {
    	if(!Object.keys(this.props.article.post).length) {
			this.props.fetchArticle( this.props.match.params.slug )
		}

    	if(!this.props.article.recommended.length) {
			this.props.fetchRecommendedArticles( this.props.match.params.slug )
		}

		// this.props.fetchComments( this.props.match.params.slug )
	}

    componentDidMount() {
		this.props.postViewHistory( 'articles', this.props.match.params.slug )
		window.addEventListener('scroll', this.onScroll)
		if( window.location.hash === '#comments' ) {
			animateScroll.scrollToBottom();
		} else {
			window.scrollTo(0, 0)
		}
	}

    componentDidUpdate(prevProps, prevState) {

    	if(!this.props.article.post) return;

		let prevArticle = prevState.article,
			nextArticle = this.props.article.post,
			prevArticleSet = 'ID' in prevArticle,
			nextArticleSet = 'ID' in nextArticle;

		if( prevArticleSet && nextArticleSet && prevArticle.slug !== nextArticle.slug ) return

		if( !('ID' in prevArticle) && 'ID' in nextArticle ) {
			this.setState({
				article: nextArticle
			})
			return;
		}

		let bookmarkChanged = prevArticle.bookmarked !== nextArticle.bookmarked,
			flareChanged = prevArticle.flared !== nextArticle.flared,
			commentsChanged = prevArticle.comment_count !== nextArticle.comment_count;

		if( nextArticleSet && (bookmarkChanged || flareChanged || commentsChanged) ) {
			this.setState({
				article: nextArticle
			})
		}

	}

    onScroll = (element) => {
		// Progress is updated by the top of the view port. When progress is at 100%, that means they've gone past the article and comments have just come into view.
		let dom = ReactDOM.findDOMNode(this.refs.the_article);
		if( !dom ) return;
		let bounding = dom.getBoundingClientRect(),
			distanceTravelled = -bounding.top,
			progress = (distanceTravelled * 100 / bounding.height).toFixed(0);
		progress = progress > 100 ? 100 : (progress < 0 ? 0 : progress);
		if(+progress <= +this.progress) return; 
		this.progress = +progress;
    };

    render() {

		var article = this.state.article,
			fetching = !('ID' in article) && this.props.article.fetching,
			comments = this.props.article.comments,
			recommended = this.props.article.recommended;

		//console.log(article)

		return (
			<div className="p20 pbot0-xs" id="article-page">

				{ !fetching.article && article && 'user' in article && 
					<MetaData page="article" vars={article} />
	            }

            	{ !fetching.article && article && 'user' in article &&
					<div className="row ptop20 pbot20 ptop0-xs">
						<div className="col-sm-10 col-xs-8">
							<User {...article.user} />
						</div>
						<div className="col-sm-2 col-xs-4 ptop10-xs">
							{ 'ID' in this.props.session.user &&
								<Ranking articleID={article.ID} flared={article.flared} bookmarked={article.bookmarked} />
							}
						</div>
					</div>
            	}
            	{ fetching.article
            		? <TextLoader />
		            : ( article && 'title' in article
	            		? <div>
	            			<div ref="the_article" id="the_article">
				            	{ !fetching.article && 'images' in article &&
									<FeaturedImage {...article.images} />
				            	}
				            	<SocialIcons className="mtop30" />
				            	<Content {...article} />
			            	</div>
							{ this.props.session.sessionsAllowed &&
								<Actions articleID={article.ID}
										 bookmarks={article.bookmarks.length}
										 bookmarked={article.bookmarked}
										 comment_count={article.comment_count}
										 flares={article.flares.length}
										 flared={article.flared}
										 title={article.title}/>
							}
							<div className="clearfix" />
							<div className="row ptop20 pbot20">
								<div className="col-sm-10">
									<User {...article.user} />
								</div>
							</div>
			            	{ fetching.recommended
			            		? <TextLoader />
					            : <Recommended recommended={recommended} history={this.props.history} />
			        		}
			        		{'images' in article && this.props.session.sessionsAllowed &&
								<Comments articleID={article.ID} fetching={fetching.comments} comments={comments} />
			        		}
            			</div>
		            	: <NoArticle />
		            )
        		}
			</div>
		)
		
	}

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
		this.props.updateViewHistory( 'articles', this.props.match.params.slug, this.progress )
		this.props.removeArticle()
	}

}

const mapStateToProps = state => ({
    articles: state.articles,
    feed: state.feed,
    session: state.session,
    notifications: state.notifications,
    article: state.article,
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchArticle, fetchComments, fetchRecommendedArticles, updateViewHistory, removeArticle, postViewHistory }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Article);



// WEBPACK FOOTER //
// ./src/js/views/Article/index.js